import { FlexProps, chakra } from "@chakra-ui/react";
import { useContext, useEffect } from "react";
import { MdChevronRight } from "react-icons/md";

import { Icon } from "../icon";

import { NavigationPanelContext, useStyles } from "./navigation-panel.tsx";
interface NavigationPanelToggleProps extends Omit<FlexProps, "children"> {
  label?: string;
  hideOnCollapse?: boolean;
  hideOnExpand?: boolean;
  stateChange?: (open: boolean) => void;
}

export const NavigationPanelToggle = (props: NavigationPanelToggleProps) => {
  const { label, hideOnCollapse, hideOnExpand,stateChange , ...rest } = props;
  const { open, toggle } = useContext(NavigationPanelContext);

  const styles = useStyles();

  useEffect(() => {
    if (stateChange) {
      stateChange(open);
    }
  }, [open, stateChange]);

  if (hideOnCollapse && !open) {
    return null;
  }

  if (hideOnExpand && open) {
    return null;
  }

  if (!label) {
    return (
      <chakra.button
        __css={styles.switcher}
        {...rest}
        onClick={() => {
          toggle((prev) => !prev);
        }}
        aria-expanded={open}
      >
        <Icon as={MdChevronRight} height="2rem" width={"2rem"} />
      </chakra.button>
    );
  }

  return (
    <chakra.button
      __css={styles.item}
      {...rest}
      onClick={() => {
        toggle((prev) => !prev);
      }}
    >
      <chakra.div __css={styles.itemContainer} aria-expanded={open}>
        <chakra.span __css={styles.icon}>
          <MdChevronRight
            className={`transition-all duration-300 cursor-pointer ${
              open ? "rotate-180" : "rotate-0"
            }`}
          />
        </chakra.span>
        {open && (
          <chakra.span __css={styles.labelContainer}>
            <chakra.span aria-expanded={open} __css={styles.label}>
              {label}
            </chakra.span>
          </chakra.span>
        )}
      </chakra.div>
    </chakra.button>
  );
};
